import ActionClauseType from '../../store/schema/ActionClauseType';

export default function getActionClauseTypeOptions(): ActionClauseType[] {
    //******** MUST READ ********//
    // Must keep in order by dropdown section!
    return [
        // Organize
        'moveTo',
        'copyTo',
        'delete',
        'pin',

        // Mark message
        'read',
        'junk',
        'markImportance',
        'category',

        // Route
        'forwardTo',
        'forwardAsAttachmentTo',
        'redirectTo',
    ];
}
